module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "scrollable": "",
      "width": "800px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.primaryInf) ? _c('v-card', [_c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      Merge Influencer\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "height": "700px",
      "margin-top": "20px"
    }
  }, [_c('v-alert', {
    attrs: {
      "dense": "",
      "text": "",
      "type": "warning"
    }
  }, [_vm._v("\n        Please check and merge the influencers\n      ")]), _vm._v(" "), _c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.openExpansion),
      callback: function($$v) {
        _vm.openExpansion = $$v
      },
      expression: "openExpansion"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("\n            Contact Information\n          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [(_vm.isEmail) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.email),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "email", $$v)
      },
      expression: "comparisons.email"
    }
  }, [(_vm.primaryInf.email) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.email,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.email) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.email,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isPhone) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Contact Number")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.phone),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "phone", $$v)
      },
      expression: "comparisons.phone"
    }
  }, [(_vm.primaryInf.phone) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.phone,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.phone) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.phone,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("\n            Billing Information\n          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [(_vm.isBankName) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Bank name")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.bankName),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "bankName", $$v)
      },
      expression: "comparisons.bankName"
    }
  }, [(_vm.primaryInf.bankName) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.bankName,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.bankName) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.bankName,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.isBankAccount) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Bank account")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.bankAccount),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "bankAccount", $$v)
      },
      expression: "comparisons.bankAccount"
    }
  }, [(_vm.primaryInf.bankAccount) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.bankAccount,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.bankAccount) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.bankAccount,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [(_vm.isFullName) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Fullname as per Bank Account")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.fullName),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "fullName", $$v)
      },
      expression: "comparisons.fullName"
    }
  }, [(_vm.primaryInf.fullName) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.fullName,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.fullName) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.fullName,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.isCountry) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.country),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "country", $$v)
      },
      expression: "comparisons.country"
    }
  }, [(_vm.primaryInf.country) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.country,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.country) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.country,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [(_vm.isMailingAddress) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('label', [_vm._v("Mailing address")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.mailingAddress),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "mailingAddress", $$v)
      },
      expression: "comparisons.mailingAddress"
    }
  }, [(_vm.primaryInf.mailingAddress) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.mailingAddress,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.mailingAddress) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.mailingAddress,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("\n            Your Rates "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "margin-left": "5px"
    }
  }, [_vm._v("(in SGD per item)")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-tabs', {
    staticClass: "mb-3",
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [(_vm.primaryInf.audience) ? _c('v-tab', {
    attrs: {
      "href": "#tab-1"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.primaryInf.audience.user_profile ? _vm.primaryInf.audience.user_profile.fullname : '') + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.primaryInf.tiktokaudience && !_vm.primaryInf.audience && !_vm.primaryInf.youtubeaudience) ? _c('v-tab', {
    attrs: {
      "href": "#tab-1"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.primaryInf.tiktokaudience.user_profile ? _vm.primaryInf.tiktokaudience.user_profile.fullname : '') + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.primaryInf.youtubeaudience && !_vm.primaryInf.audience && !_vm.primaryInf.tiktokaudience) ? _c('v-tab', {
    attrs: {
      "href": "#tab-1"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.primaryInf.youtubeaudience.user_profile ? _vm.primaryInf.youtubeaudience.user_profile.fullname : '') + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.compareInf.audience) ? _c('v-tab', {
    attrs: {
      "href": "#tab-2"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.compareInf.audience.user_profile ? _vm.compareInf.audience.user_profile.fullname : '') + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.compareInf.tiktokaudience) ? _c('v-tab', {
    attrs: {
      "href": "#tab-2"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.compareInf.tiktokaudience.user_profile ? _vm.compareInf.tiktokaudience.user_profile.fullname : '') + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.compareInf.youtubeaudience) ? _c('v-tab', {
    attrs: {
      "href": "#tab-2"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.compareInf.youtubeaudience.user_profile ? _vm.compareInf.youtubeaudience.user_profile.fullname : '') + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: 1,
    attrs: {
      "value": "tab-1"
    }
  }, [_c('inputed-rates', {
    attrs: {
      "inputedRates": _vm.inputedRates
    }
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    attrs: {
      "value": "tab-2"
    }
  }, [_c('inputed-rates', {
    attrs: {
      "inputedRates": _vm.compareInputedRates
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("\n            Additional Information\n          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [(_vm.isGender) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Gender")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.gender),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "gender", $$v)
      },
      expression: "comparisons.gender"
    }
  }, [(_vm.primaryInf.gender) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.userGender_options[_vm.primaryInf.gender] ? _vm.userGender_options[_vm.primaryInf.gender] : '-',
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.gender) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.userGender_options[_vm.compareInf.gender] ? _vm.userGender_options[_vm.compareInf.gender] : '-',
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.isBirthday) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Birthday")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.birthday),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "birthday", $$v)
      },
      expression: "comparisons.birthday"
    }
  }, [(_vm.primaryInf.birthday) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.birthday,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.birthday) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.birthday,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('v-btn', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.saveMerge
    }
  }, [_vm._v("Save changes")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73a2b453"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/InfPlatforms/ComparisonModal.vue
// module id = 2195
// module chunks = 0